import './tooltip.css';

function determinPosition(props) {
	if (props.position === "bottom") {
		return "bottom";
	}
	if (props.position === "left") {
		return "left";
	}
	if (props.position === "right") {
		return "right";
	}
	return "top";
}

export function Tooltip(props) {
	const position = determinPosition(props);
	return (
		<div className={`tooltip ${position}`}>
			{props.children}
			<div className="tooltip-content" dangerouslySetInnerHTML={{__html: props.text}}>
			</div>
		</div>
	);
}